import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgStyle = function SvgStyle(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M17.836 6.88c.28.601-.12 1.442 0 2.042.12.64.76 1.281.72 1.922-.04.64-.84 1.16-1.04 1.761-.24.6.04 1.481-.36 2.042-.361.52-1.282.6-1.802 1-.48.4-.72 1.322-1.321 1.602-.6.28-1.441-.12-2.042 0-.64.12-1.281.76-1.922.72-.64-.04-1.16-.84-1.761-1.04-.6-.24-1.481.04-2.042-.36-.52-.36-.6-1.282-1-1.802-.4-.48-1.321-.72-1.602-1.321-.28-.6.12-1.441 0-2.042-.12-.64-.76-1.28-.72-1.921.04-.64.84-1.161 1.04-1.762.24-.6-.04-1.481.36-2.041.401-.52 1.282-.6 1.802-1.001.48-.4.72-1.321 1.321-1.602.6-.28 1.442.12 2.042 0 .64-.12 1.281-.76 1.921-.72.681.08 1.202.84 1.802 1.08.6.241 1.481-.04 2.042.361.52.36.6 1.281 1 1.802.4.44 1.281.68 1.562 1.28Z",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M10.75 14.166a4.003 4.003 0 1 0 0-8.006 4.003 4.003 0 0 0 0 8.006Z",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeMiterlimit: 10
    }))]
  }));
};
export default SvgStyle;